import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";

interface AnimatedGradientBackgroundProps {
  className?: string;
  containerClassName?: string;
  colors?: string[];
  children: React.ReactNode;
}

export const AnimatedGradientBackground = ({
  className,
  containerClassName,
  colors = [
    "rgba(56, 189, 248, 0.3)",  // Light blue
    "rgba(232, 121, 249, 0.25)", // Light pink
    "rgba(99, 102, 241, 0.3)",   // Indigo
  ],
  children,
}: AnimatedGradientBackgroundProps) => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!containerRef.current) return;
      
      const rect = containerRef.current.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      
      setCursorPosition({ x, y });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={cn("relative overflow-hidden", containerClassName)}
    >
      <div className="absolute inset-0 z-0">
        {colors.map((color, i) => (
          <div
            key={i}
            className="absolute rounded-full mix-blend-normal filter blur-[80px] opacity-50 animate-pulse"
            style={{
              backgroundColor: color,
              width: `${500 + i * 100}px`,
              height: `${500 + i * 100}px`,
              top: `${50 + Math.sin(i) * 20 - cursorPosition.y * 30}%`,
              left: `${i * 30 + cursorPosition.x * 20}%`,
              transform: "translate(-50%, -50%)",
              animation: `pulse ${8 + i * 2}s ease-in-out infinite alternate`,
            }}
          />
        ))}
      </div>
      <div className={cn("relative z-10", className)}>{children}</div>
    </div>
  );
}; 